import { Component, OnInit, ɵConsole ,Input } from '@angular/core';
import { Service } from '../../services';
import { GlobalService } from '../../global.service';
import { LoadingScreenService } from '../../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";
@Component({
  selector: 'app-paperless-box',
  templateUrl: './paperless-box.component.html',
  styleUrls: ['./paperless-box.component.sass']
})
export class PaperlessBoxComponent implements OnInit {
  public paperless=false;
  @Input() email;
  public newEmail;
  @Input() currentBan;
  @Input() loadingData;
  public check1;
  loadObserver: Subscription;

  constructor(private services: Service,private loadingScreenService :LoadingScreenService, private global:GlobalService) { }

  ngOnInit() {
    //ajustar esto
    this.paperless=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
    if(this.loadingData!=false){
      this.getPersonalData(this.currentBan);
    }
    else{
      this.email=JSON.parse(atob(sessionStorage.getItem("GetPersonalData"))).Email;
      this.newEmail='';
    }
    this.loadObserver = this.global.loadObserver.subscribe((data:object) => {
      this.paperless=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
    });
  }
  updatepaperless(){
    this.global.validateSession();
    if(this.paperless==false){
      this.loadingScreenService.startLoadingMin();
      let token=JSON.parse(atob(sessionStorage.getItem("getAcoout"))).token;
        this.services.updatePaperless(this.currentBan,token).subscribe(data =>{
          this.check1 = document.getElementById("checkboxPeperless") as HTMLInputElement;
          if(data.HasError ==false){  
            this.paperless=true;
            this.loadingScreenService.stopLoadingMin();
            if(data.ErrorDesc!=''&&data.ErrorDesc!=undefined&&data.ErrorDesc!=null){
              this.global.notif(data.ErrorDesc);
            }
          }
          else{
            this.check1.checked=false;
            this.loadingScreenService.stopLoadingMin();
            this.global.notif(data.ErrorDesc);
          }
        });
      
    }
    else{
      this.paperless=false;
    }
  }
  updateEmail(){
    this.global.validateSession();
    if(this.newEmail!=""){
      if(this.global.validarEmail(this.newEmail)==true){
        let actualData=JSON.parse(atob(sessionStorage.getItem("GetPersonalData")));
        this.loadingScreenService.startLoadingMin();
        this.services.updatePersonalData(sessionStorage.getItem("token"),sessionStorage.getItem("selectBan"),btoa(actualData.CelularPhone),btoa(actualData.PhoneNumber),btoa(this.newEmail)).subscribe(data =>{
          if(data.hasError ==false){
          this.loadingScreenService.stopLoadingMin();
          
           sessionStorage.setItem("updatePersonalData",btoa(JSON.stringify(data)));
           
          this.global.notif(data.errorDesc);
          this.email=this.newEmail;
          }
          else{
            this.loadingScreenService.stopLoadingMin();
            this.global.notif(data.errorDesc);
          }
        });
      }
      else{
        this.global.notif("Estimado cliente, el Correo Electrónico tiene un formato incorrecto.");
      }
    }
  }
  getPersonalData(account){
    this.services.getPersonalData(sessionStorage.getItem("token"),account).subscribe(data =>{
      if(data.HasError ==false){
        sessionStorage.setItem("GetPersonalData",btoa(JSON.stringify(data)));
        this.email=data.Email;
        this.newEmail='';
      }
      else{
        this.global.notif(data.ErrorDesc);
      }
    });
  }
  ngOnDestroy() {
    this.loadObserver.unsubscribe();
  }
}
